import { createContext, useContext } from 'react';

import type { ApiClient } from '../create-api-client';

interface ApiClientContext {
	apiClient: ApiClient;
}

export const ApiClientContext = createContext<ApiClientContext | null>(null);

export function useApiClient(): ApiClient {
	const ctx = useContext(ApiClientContext);
	if (!ctx?.apiClient) {
		throw new Error('useApiClient must be used inside <ApiClientProvider>');
	}
	return ctx.apiClient;
}
